var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#212121",
    className: "file-html_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.597 36h-2.132v-3.201H11V36H8.867v-7.853H11v2.911h2.465v-2.911h2.132V36zM20.759 36h-2.122v-6.117H16.72v-1.735h5.951v1.735h-1.912V36zM27.215 36l-1.606-5.656h-.048c.075.964.113 1.712.113 2.246V36h-1.88v-7.853h2.825l1.638 5.575h.043l1.606-5.575h2.831V36h-1.95v-3.443c0-.179.003-.377.008-.596.006-.219.03-.754.073-1.605h-.048L29.234 36h-2.019zM34.428 36v-7.853h2.122v6.14h3.024V36h-5.146z",
    fill: "#212121",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M29 2v12h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 23v-9L29 2H7v21M7 41v5h34v-5M2 23h44v18H2z"
  }))));
}

export default SvgFileHtml;